import { isMobile } from "src/utils/device";
import MainPageDesk from  "./MainPage";
import MainPageMobile from "./MainPageMobile";

const MainPage = () => {
    return isMobile() ? <MainPageMobile /> : <MainPageDesk />;
};

export default MainPage;